<template>
  <van-popup
    v-model="showContent"
    :get-container="getContainer"
    :transition-appear="true"
    :safe-area-inset-bottom="true"
    @closed="hideContent"
  >
    <transition name="scale-in" appear>
      <div v-if="showContent" class="popup-container">
        <div>
          <p v-if="title" class="popup-container-title">{{ title }}</p>
          <div
            class="popup-container-content"
            :class="textAlign"
            v-html="content"
          ></div>
          <p v-if="tips" class="popup-container-tips">{{ tips }}</p>
          <div v-if="type == 'tips'" class="popup-container-btns">
            <Button class="btn" @click="sendConfirmEvt">
              {{ myConfirm }}
            </Button>
          </div>
          <div v-else class="popup-container-btns">
            <Button class="btn" type="default" @click="sendCancelEvt">
              {{ myCancel }}
            </Button>
            <Button class="btn" @click="sendConfirmEvt">
              {{ myConfirm }}
            </Button>
          </div>
        </div>
        <Close class="popup-close" @click="hideContent"></Close>
      </div>
    </transition>
  </van-popup>
</template>

<script>
import Button from '@components/officialPassport/common/Button.vue';
import Close from '@components/officialPassport/common/Close.vue';
import { Popup } from 'vant';

export const CLOSE_DIALOG_EVENT = 'close_dialog';
export const CANCEL_EVENT = 'onCancel';
export const CONFIRM_EVENT = 'onConfirm';
export const SHOW_TIPS = 'showTipsDialog';
export const RESET_CONFIG = 'resetConfig';

export default {
  components: {
    Button,
    Close,
    Popup
  },
  props: [
    'visible',
    'content',
    'title',
    'cancel',
    'confirm',
    'languages',
    'type',
    'tips',
    'textAlign'
  ],
  data() {
    return {
      operateType: ''
    };
  },
  computed: {
    myCancel() {
      let cancel = '';
      try {
        cancel = this.cancel || this.languages.cancel.toUpperCase();
      } catch {
        cancel = 'CANCEL';
      }
      return cancel;
    },
    myConfirm() {
      let confirm = '';
      try {
        confirm = this.confirm || this.languages.confirm.toUpperCase();
      } catch {
        confirm = 'COMFIRM';
      }
      return confirm;
    },
    showContent: {
      get() {
        return this.visible;
      },
      set(bool) {
        this.$emit('update:visible', bool);
      }
    }
  },
  methods: {
    getContainer() {
      return document.querySelector('.official-passport-page');
    },
    closeDialog() {
      this.$emit(CANCEL_EVENT);
      if (this.operateType === 'confirm') {
        this.$emit(CONFIRM_EVENT);
      }
      this.operateType = '';
    },
    hideContent() {
      this.showContent = false;
      this.closeDialog();
    },
    sendCancelEvt() {
      this.operateType = 'cancel';
      this.hideContent();
    },
    sendConfirmEvt() {
      this.operateType = 'confirm';
      this.hideContent();
    }
  }
};
</script>

<style lang="scss" scoped>
.popup {
  z-index: 11;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  &-container {
    z-index: 10;
    overflow: auto;
    box-sizing: border-box;
    position: relative;
    width: 550px;
    max-height: 100vh;
    padding: 50px 30px 30px;
    background-color: var(--page-bgColor);
    border-radius: var(--border-radius);

    &-title {
      width: 100%;
      margin-bottom: 60px;
      font-size: 32px;
      line-height: 40px;
      text-align: center;
    }

    &-content {
      box-sizing: border-box;
      display: inline-block;
      width: 100%;
      min-height: 52px;
      margin: 0 auto;
      padding-top: 10px;
      text-align: center;
      font-size: 24px;
      line-height: 40px;
      vertical-align: middle;
      clear: both;
    }

    &-tips {
      margin-top: 50px;
      line-height: 150%;
      text-align: center;
      font-size: 18px;
      color: red;
    }

    &-btns {
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 30px;
      width: 100%;
      margin-top: 80px;
      text-align: center;

      .btn {
        flex: 1;
      }
    }
  }

  &-close {
    position: absolute;
    top: 22px;
    right: 22px;
  }

  &-mask {
    z-index: 1;
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
  }

  &.has-other-tips {
    .popup-container-btns {
      margin-top: 20px;
    }
  }
}
</style>
